import { Injectable } from '@angular/core';

@Injectable()
export class ContribBiennaleFieldValidators {
    // RULE: add here only validators that read ONLY the single control value.
    constructor() {}
}
